import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcConfiguration = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M6.497 13.784a1 1 0 0 0-1 0L2.6 15.457a1 1 0 0 0-.5.866v3.345a1 1 0 0 0 .5.866l2.897 1.673a1 1 0 0 0 1 0l2.897-1.673a1 1 0 0 0 .5-.866v-3.345a1 1 0 0 0-.5-.866l-2.897-1.673Zm-.5 5.712a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M6.964 5.418c-.246-.247-.661-.17-.76.163a5 5 0 0 0 7.108 5.853l6.627 6.627a1.5 1.5 0 0 0 2.122-2.121l-6.627-6.627a5 5 0 0 0-5.86-7.107c-.333.1-.409.514-.163.76l2.666 2.666-.517 1.932-1.932.518-2.664-2.664Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcConfiguration");

export { IcConfiguration };
//# sourceMappingURL=ic-configuration.js.map
